import script from "./BlockImage.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockImage.vue?vue&type=script&setup=true&lang=js"

import "./BlockImage.vue?vue&type=style&index=0&id=4cf4b938&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf4b938"]])

export default __exports__